import React from "react";
import axios from "axios";
import validator from 'validator';
import { notifications } from '@mantine/notifications';
import { Textarea, Group, Text, Select, useMantineTheme, Loader, Rating, Box, RingProgress, Button } from '@mantine/core';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_TWO, BE_API_THREE, utils } from "../../utils/globalVariables";
import { regexNumberOnly, numberWithComma, isoDateToSqlDate, formatNumberCanZeroMinus } from "../../utils/globalFunctions";

import { canAccessModifyRatingProjectTeknisi } from "../../utils/accessing";

import PickerDate from "../../components/general/PickerDate";
import ModalResponse from "../../components/general/ModalResponse";
import ModalTakeAction from "../../components/general/ModalTakeAction";
import PaperWrapper from "../../components/utilities/PaperWrapper";
import InputWrapperCustom from "../../components/general/InputWrapperCustom";
import InputComponent from "../../components/general/InputComponent";

const StepSelesaiTotalPembayaran = ({ stateData, fnOnChangeDiskon, fnOnChangeStatusLunas, fnOnChangePelunasanMetode, fnOnChangePelunasanTanggal, fnOnChangePengambilanTanggal, fnOnChangeCatatanSelesai, fnOnChangeProjectRating }) => {

    const mountedRef = React.useRef(true);
    const { loginContext, handleSetLoginContext } = useLoginContext();
    const theme = useMantineTheme();

    const notificationId = React.useRef({
        errorUpdateDiskon: 'stepSelesaiTotalPembayaran-1',
        errorUpdateStatusLunas: 'stepSelesaiTotalPembayaran-2',
        errorUpdateMetodePelunasan: 'stepSelesaiTotalPembayaran-3',
        errorUpdateTanggalPelunasan: 'stepSelesaiTotalPembayaran-4',
        errorUpdateTanggalPengambilan: 'stepSelesaiTotalPembayaran-5',
        errorUpdateCatatanPengambilan: 'stepSelesaiTotalPembayaran-6',
        errorUpdateProjectRating: 'stepSelesaiTotalPembayaran-7',
    })

    const [data, setData] = React.useState({
        diskon: {
            modal: false,
            value: '0',
            valueError: '',
            submitLoading: false
        },

        statusLunas: {
            submitLoading: false,
        },

        metodePelunasan: {
            submitLoading: false,
        },

        tanggalPelunasan: {
            submitLoading: false,
        },

        tanggalPengambilan: {
            submitLoading: false,
        },

        catatanPengambilan: {
            modal: false,
            value: '',
            submitLoading: false,
        },

        projectRating: {
            modal: false,
            value: 0,
            submitLoading: false,
        },

        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        }
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    const submitDiskon = () => {
        setData(d => ({ ...d, diskon: { ...d.diskon, valueError: '' } }));

        if (validator.isEmpty(data.diskon.value, { ignore_whitespace: true })) {
            setData(d => ({ ...d, diskon: { ...d.diskon, valueError: 'Diskon item wajib diisi.' } }));
        } else {
            setData(d => ({ ...d, diskon: { ...d.diskon, submitLoading: true } }));

            const formDT = new FormData();
            const formDTHeader = { 'Content-Type': 'application/json' }

            formDT.append('json_token', loginContext.syswebapp);
            formDT.append('project_id', stateData.projectId);
            formDT.append('project_process', stateData.projectProcess);
            formDT.append('project_is_cancel', stateData.projectIsCancel);

            formDT.append('diskon', data.diskon.value);

            axios({
                method: 'post',
                url: BE_API_TWO + '/pembayaran_diskon',
                data: formDT,
                headers: formDTHeader,
            }).then((response) => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, diskon: { ...d.diskon, submitLoading: false, modal: false } }));

                if (response.data.flag_status === 'isset') {
                    fnOnChangeDiskon(response.data.data);

                    setData(d => ({ ...d, diskon: { ...d.diskon, value: '' } }));
                }

                if (response.data.flag_status === 'error') {
                    notifications.show({
                        id: notificationId.current.errorUpdateDiskon,
                        title: utils.notification.warning.caption,
                        message: response.data.pesan,
                        color: utils.notification.warning.color,
                        icon: utils.notification.warning.icon,
                        withBorder: true,
                        autoClose: true,
                    })
                }

                if (response.data.flag_status === 'no-data') {
                    setData(d => ({
                        ...d,
                        modalResponse: {
                            ...d.modalResponse,
                            type: utils.modalResponse.warning,
                            hideOnClickOutSide: true,
                            content: 'Data tidak ditemukan.',
                            show: true
                        }
                    }))
                }

                if (response.data.flag_status === 'invalid-json-token') {
                    handleSetLoginContext(null);
                }

                if (response.data.flag_status === 'user-inactive') {
                    handleSetLoginContext(null);
                }
            }).catch(error => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, diskon: { ...d.diskon, submitLoading: false, modal: false } }));

                notifications.show({
                    id: notificationId.current.errorUpdateDiskon,
                    title: utils.notification.warning.caption,
                    message: error.message,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            })
        }
    }

    const submitStatusLunas = (val) => {
        setData(d => ({ ...d, statusLunas: { ...d.statusLunas, submitLoading: true } }));

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', loginContext.syswebapp);
        formDT.append('project_id', stateData.projectId);
        formDT.append('project_process', stateData.projectProcess);
        formDT.append('project_is_cancel', stateData.projectIsCancel);

        formDT.append('status_lunas', val);

        axios({
            method: 'post',
            url: BE_API_TWO + '/pembayaran_status_lunas',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, statusLunas: { ...d.statusLunas, submitLoading: false } }));

            if (response.data.flag_status === 'isset') {
                fnOnChangeStatusLunas(response.data.data);
            }

            if (response.data.flag_status === 'error') {
                notifications.show({
                    id: notificationId.current.errorUpdateStatusLunas,
                    title: utils.notification.warning.caption,
                    message: response.data.pesan,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            }

            if (response.data.flag_status === 'no-data') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Data tidak ditemukan.',
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContext(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContext(null);
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, statusLunas: { ...d.statusLunas, submitLoading: false } }));

            notifications.show({
                id: notificationId.current.errorUpdateStatusLunas,
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: true,
            })
        })
    }

    const submitMetodePelunasan = (val) => {
        setData(d => ({ ...d, metodePelunasan: { ...d.metodePelunasan, submitLoading: true } }));

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', loginContext.syswebapp);
        formDT.append('project_id', stateData.projectId);
        formDT.append('project_process', stateData.projectProcess);
        formDT.append('project_is_cancel', stateData.projectIsCancel);

        formDT.append('metode_pelunasan', val);

        axios({
            method: 'post',
            url: BE_API_TWO + '/pembayaran_metode_pelunasan',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, metodePelunasan: { ...d.metodePelunasan, submitLoading: false } }));

            if (response.data.flag_status === 'isset') {
                fnOnChangePelunasanMetode(val);
            }

            if (response.data.flag_status === 'error') {
                notifications.show({
                    id: notificationId.current.errorUpdateMetodePelunasan,
                    title: utils.notification.warning.caption,
                    message: response.data.pesan,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            }

            if (response.data.flag_status === 'no-data') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Data tidak ditemukan.',
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContext(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContext(null);
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, metodePelunasan: { ...d.metodePelunasan, submitLoading: false } }));

            notifications.show({
                id: notificationId.current.errorUpdateMetodePelunasan,
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: true,
            })
        })
    }

    const submitTanggalPelunasan = (val) => {
        setData(d => ({ ...d, tanggalPelunasan: { ...d.tanggalPelunasan, submitLoading: true } }));

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', loginContext.syswebapp);
        formDT.append('project_id', stateData.projectId);
        formDT.append('project_process', stateData.projectProcess);
        formDT.append('project_is_cancel', stateData.projectIsCancel);

        formDT.append('tanggal_pelunasan', isoDateToSqlDate(val, ''));

        axios({
            method: 'post',
            url: BE_API_TWO + '/pembayaran_tanggal_pelunasan',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, tanggalPelunasan: { ...d.tanggalPelunasan, submitLoading: false } }));

            if (response.data.flag_status === 'isset') {
                fnOnChangePelunasanTanggal(val);
            }

            if (response.data.flag_status === 'error') {
                notifications.show({
                    id: notificationId.current.errorUpdateTanggalPelunasan,
                    title: utils.notification.warning.caption,
                    message: response.data.pesan,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            }

            if (response.data.flag_status === 'no-data') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Data tidak ditemukan.',
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContext(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContext(null);
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, tanggalPelunasan: { ...d.tanggalPelunasan, submitLoading: false } }));

            notifications.show({
                id: notificationId.current.errorUpdateTanggalPelunasan,
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: true,
            })
        })
    }

    const submitTanggalPengambilan = (val) => {
        setData(d => ({ ...d, tanggalPengambilan: { ...d.tanggalPengambilan, submitLoading: true } }));

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', loginContext.syswebapp);
        formDT.append('project_id', stateData.projectId);
        formDT.append('project_process', stateData.projectProcess);
        formDT.append('project_is_cancel', stateData.projectIsCancel);

        formDT.append('tanggal_pengambilan', val ? isoDateToSqlDate(val, '') : '');

        axios({
            method: 'post',
            url: BE_API_TWO + '/pembayaran_tanggal_pengambilan',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, tanggalPengambilan: { ...d.tanggalPengambilan, submitLoading: false } }));

            if (response.data.flag_status === 'isset') {
                fnOnChangePengambilanTanggal(val);
            }

            if (response.data.flag_status === 'error') {
                notifications.show({
                    id: notificationId.current.errorUpdateTanggalPengambilan,
                    title: utils.notification.warning.caption,
                    message: response.data.pesan,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            }

            if (response.data.flag_status === 'no-data') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Data tidak ditemukan.',
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContext(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContext(null);
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, tanggalPengambilan: { ...d.tanggalPengambilan, submitLoading: false } }));

            notifications.show({
                id: notificationId.current.errorUpdateTanggalPengambilan,
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: true,
            })
        })
    }

    const submitCatatanSelesai = () => {
        setData(d => ({ ...d, catatanPengambilan: { ...d.catatanPengambilan, submitLoading: true } }));

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', loginContext.syswebapp);
        formDT.append('project_id', stateData.projectId);
        formDT.append('project_process', stateData.projectProcess);
        formDT.append('project_is_cancel', stateData.projectIsCancel);

        formDT.append('catatan_pengambilan', data.catatanPengambilan.value);

        axios({
            method: 'post',
            url: BE_API_TWO + '/pembayaran_catatan_pengambilan',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, catatanPengambilan: { ...d.catatanPengambilan, submitLoading: false, modal: false } }));

            if (response.data.flag_status === 'isset') {
                fnOnChangeCatatanSelesai(data.catatanPengambilan.value);
            }

            if (response.data.flag_status === 'error') {
                notifications.show({
                    id: notificationId.current.errorUpdateCatatanPengambilan,
                    title: utils.notification.warning.caption,
                    message: response.data.pesan,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            }

            if (response.data.flag_status === 'no-data') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Data tidak ditemukan.',
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContext(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContext(null);
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, catatanPengambilan: { ...d.catatanPengambilan, submitLoading: false, modal: false } }));

            notifications.show({
                id: notificationId.current.errorUpdateCatatanPengambilan,
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: true,
            })
        })
    }

    const submitProjectRating = () => {
        setData(d => ({ ...d, projectRating: { ...d.projectRating, submitLoading: true } }));

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', loginContext.syswebapp);
        formDT.append('project_id', stateData.projectId);
        formDT.append('project_process', stateData.projectProcess);
        formDT.append('project_is_cancel', stateData.projectIsCancel);

        formDT.append('rating', data.projectRating.value);

        axios({
            method: 'post',
            url: BE_API_THREE + '/set_project_rating',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({
                ...d,
                projectRating: { ...d.projectRating, submitLoading: false, modal: false }
            }));

            if (response.data.flag_status === 'isset') {
                fnOnChangeProjectRating(data.projectRating.value);
            }

            if (response.data.flag_status === 'error') {
                notifications.show({
                    id: notificationId.current.errorUpdateProjectRating,
                    title: utils.notification.warning.caption,
                    message: response.data.pesan,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            }

            if (response.data.flag_status === 'no-data') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Data tidak ditemukan.',
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContext(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContext(null);
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({
                ...d,
                projectRating: { ...d.projectRating, submitLoading: false, modal: false }
            }));

            notifications.show({
                id: notificationId.current.errorUpdateProjectRating,
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: true,
            })
        })
    }

    return (
        <React.Fragment>
            <PaperWrapper stateMB="1.5rem">
                <Text size='sm' fw='500'>
                    Total Biaya Stock: Rp {numberWithComma(stateData.totalBiayaStock)}
                </Text>

                <Text size='sm' fw='500'>
                    Total Biaya Jasa: Rp {numberWithComma(stateData.totalBiayaJasa)}
                </Text>

                <Text size='sm' fw='500'>
                    Potongan: {stateData.discVoucherNameRes}
                </Text>

                <Text size='sm' fw='500'>
                    Jumlah Potongan: Rp {numberWithComma(stateData.discVoucherRes)}
                </Text>

                <InputComponent
                    stateMT="1rem"
                    stateId='pembayaranSubTotal-1'
                    stateClassName='forceResetForDisabledReadOnlyLight'
                    stateWithAsterisk={false}
                    stateLabel='Sub Total'
                    stateDescription=''
                    statePlaceHolder='Sub Total'
                    stateReadOnly={true}
                    stateDisabled={true}
                    stateValue={numberWithComma(stateData.subTotal)}
                    stateError=''
                    stateIcon={<Text size='sm' color="dimmed">Rp</Text>}

                    stateStylesInput={{
                        backgroundColor: `${theme.colorScheme === 'light' ? theme.colors.gray[1] : theme.colors.dark[7]} !important`,
                    }}

                    fnOnChange={() => { }}
                />

                <InputComponent
                    stateId='pembayaranDP-1'
                    stateClassName='forceResetForDisabledReadOnlyLight'
                    stateWithAsterisk={false}
                    stateLabel='Uang Muka'
                    stateDescription=''
                    statePlaceHolder='Uang Muka'
                    stateReadOnly={true}
                    stateDisabled={true}
                    stateValue={numberWithComma(stateData.dp)}
                    stateError=''
                    stateIcon={<Text size='sm' color="dimmed">Rp</Text>}

                    stateMT="1rem"

                    stateStylesInput={{
                        backgroundColor: `${theme.colorScheme === 'light' ? theme.colors.gray[1] : theme.colors.dark[7]} !important`,
                    }}

                    fnOnChange={() => { }}
                />

                <InputComponent
                    stateId='pembayaranDiskon-1'
                    stateWithAsterisk={false}
                    stateLabel='Diskon'
                    stateDescription=''
                    statePlaceHolder='Diskon'
                    stateReadOnly={true}
                    stateValue={numberWithComma(stateData.diskon)}
                    stateError=''
                    stateIcon={<Text size='sm' color="dimmed">Rp</Text>}

                    stateMT="1rem"

                    stateStylesInput={{
                        backgroundColor: `${theme.colorScheme === 'light' ? '#fff' : theme.colors.dark[8]} !important`,
                    }}

                    fnOnClick={() => {
                        setData(d => ({ ...d, diskon: { ...d.diskon, value: stateData.diskon, modal: true } }))
                    }}

                    fnOnChange={() => { }}
                />

                <InputComponent
                    stateId='pembayaranTotal-1'
                    stateClassName='forceResetForDisabledReadOnlyLight'
                    stateWithAsterisk={false}
                    stateLabel='Total'
                    stateDescription=''
                    statePlaceHolder='Total'
                    stateReadOnly={true}
                    stateDisabled={true}
                    stateValue={formatNumberCanZeroMinus(stateData.total)}
                    stateError=''
                    stateIcon={<Text size='sm' color="dimmed">Rp</Text>}

                    stateMT="1rem"

                    stateStylesInput={{
                        backgroundColor: `${theme.colorScheme === 'light' ? theme.colors.gray[1] : theme.colors.dark[7]} !important`,
                    }}

                    fnOnChange={() => { }}
                />

                <InputWrapperCustom
                    stateLabel={
                        <Group>
                            <Text>Status Lunas</Text>
                            {data.statusLunas.submitLoading && <Loader size="xs" />}
                        </Group>
                    }
                    stateWithAsterisk={false}
                    stateError=''
                    stateDescription=''
                    stateMT="1rem"
                >
                    <Select
                        value={stateData.statusLunas}
                        onChange={(val) => submitStatusLunas(val)}
                        data={[
                            { value: '0', label: 'Belum Lunas' },
                            { value: '1', label: 'Sudah Lunas' }
                        ]}

                        styles={(tema) => ({
                            input: {
                                backgroundColor: tema.colorScheme === 'light' ? '#fff' : tema.colors.dark[7]
                            }
                        })}
                    />
                </InputWrapperCustom>

                {Number(stateData.statusLunas) !== 0 &&
                    <InputWrapperCustom
                        stateLabel={
                            <Group>
                                <Text>Metode Pelunasan</Text>
                                {data.metodePelunasan.submitLoading && <Loader size="xs" />}
                            </Group>
                        }
                        stateWithAsterisk={false}
                        stateError=''
                        stateDescription=''
                        stateMT="1.5rem"
                    >
                        <Select
                            value={stateData.pelunasanMetode}
                            onChange={(val) => submitMetodePelunasan(val)}
                            data={[
                                { value: '', label: 'Pilih Metode Pelunasan' },
                                ...Object.values(utils.metodeBayar).map(key => ({ value: key.value, label: key.caption }))
                            ]}

                            styles={(tema) => ({
                                input: {
                                    backgroundColor: tema.colorScheme === 'light' ? '#fff' : tema.colors.dark[7]
                                }
                            })}
                        />
                    </InputWrapperCustom>
                }

                {Number(stateData.statusLunas) !== 0 &&
                    <PickerDate
                        stateMinDate={null}
                        stateDate={stateData.pelunasanTanggal}
                        stateVariant="default"

                        stateMT="1.5rem"

                        stateStylesInput={{
                            backgroundColor: theme.colorScheme === 'light' ? '#fff' : theme.colors.dark[7]
                        }}

                        fnSetDate={(val) => submitTanggalPelunasan(val)}

                        stateLabel={
                            <Group>
                                <Text>Tanggal Pelunasan</Text>
                                {data.tanggalPelunasan.submitLoading && <Loader size="xs" />}
                            </Group>
                        }
                        statePlaceHolder='Tanggal Pelunasan'
                        stateWithAsterisk={false}
                        stateDescription=''
                        stateError=''
                    />
                }
            </PaperWrapper>

            <PaperWrapper stateMB="1.5rem">
                <PickerDate
                    stateMinDate={null}
                    stateDate={stateData.pengambilanTanggal}
                    stateVariant="default"
                    stateClearable={true}

                    stateStylesInput={{
                        backgroundColor: theme.colorScheme === 'light' ? '#fff' : theme.colors.dark[7]
                    }}

                    fnSetDate={(val) => submitTanggalPengambilan(val)}

                    stateLabel={
                        <Group>
                            <Text>Tanggal Pengambilan</Text>
                            {data.tanggalPengambilan.submitLoading && <Loader size="xs" />}
                        </Group>
                    }
                    statePlaceHolder='Tanggal Pengambilan'
                    stateWithAsterisk={false}
                    stateDescription=''
                    stateError=''
                />

                <Textarea
                    readOnly={true}
                    value={stateData.catatanSelesai}
                    minRows={3}
                    maxRows={4}
                    onClick={() => {
                        setData(d => ({
                            ...d,
                            catatanPengambilan: {
                                ...d.catatanPengambilan,
                                value: stateData.catatanSelesai,
                                modal: true
                            }
                        }))
                    }}

                    mt='1.5rem'
                    styles={(tema) => ({
                        input: {
                            backgroundColor: tema.colorScheme === 'light' ? '#fff' : tema.colors.dark[7]
                        }
                    })}

                    label='Catatan Pengambilan'
                    placeholder='Keterangan / Catatan'
                    error=''
                    description=''
                    withAsterisk={false}
                />
            </PaperWrapper>

            {(stateData.projectProcess === utils.projectProcess.sudah_diambil.value) && canAccessModifyRatingProjectTeknisi({ stateObject: { subLevel: loginContext } }) &&
                <PaperWrapper stateMB="5rem">
                    <Text
                        fw={500}
                        size={theme.fontSizes.sm}
                        c={theme.colorScheme === 'light' ? theme.colors.gray[9] : theme.colors.dark[0]}
                        ta='center'
                    >
                        Rating Pekerjaan
                    </Text>

                    <Box
                        mt='sm'
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <RingProgress
                            sections={[{ value: Number(stateData.projectRating) * (100 / utils.projectRating), color: 'orange' }]}
                            thickness={10}
                            label={
                                <Text
                                    sx={(tema) => ({
                                        color: tema.colorScheme === 'light' ? tema.colors.yellow[6] : tema.colors.yellow[8]
                                    })}
                                    weight={500}
                                    align="center"
                                    size="xl"
                                >
                                    {String(Number(stateData.projectRating))}
                                </Text>
                            }
                        />
                    </Box>

                    <Box
                        mt='sm'
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        }}
                    >
                        <Rating
                            readOnly
                            value={Number(stateData.projectRating)}
                            onClick={() => {
                                setData(d => ({
                                    ...d,
                                    projectRating: {
                                        ...d.projectRating,
                                        value: stateData.projectRating,
                                        modal: true
                                    }
                                }))
                            }}
                            size="lg"
                            count={utils.projectRating}
                            fractions={2}

                            sx={{
                                cursor: 'pointer',
                            }}
                        />
                    </Box>
                </PaperWrapper>
            }

            <ModalTakeAction
                stateShow={data.diskon.modal}
                fnHide={() => setData(d => ({
                    ...d,
                    diskon: {
                        ...d.diskon,
                        modal: false
                    }
                }))}

                stateHideOnClickOutSide={true}
                stateTitle={String('Diskon').toUpperCase()}
                stateOverlayZIndex={201}

                stateButtonClosePx='md'

                stateButtonActionCaption='Submit'
                stateButtonActionPx='xs'
                stateButtonActionColor="blue"
                stateButtonActionLoading={data.diskon.submitLoading}
                fnButtonAction={submitDiskon}
            >
                <InputComponent
                    stateId='modul-pembayaran-diskon-1'
                    stateWithAsterisk={false}
                    stateLabel={<Text color="dimmed">Diskon</Text>}
                    stateDescription=''
                    statePlaceHolder='Diskon'
                    stateReadOnly={false}
                    stateValue={numberWithComma(data.diskon.value)}
                    stateError={data.diskon.valueError}
                    stateIcon={<Text size='sm' color="dimmed">Rp</Text>}

                    fnOnChange={(e) => setData(d => ({
                        ...d,
                        diskon: {
                            ...d.diskon,
                            value: regexNumberOnly(e.target.value)
                        }
                    }))}
                />
            </ModalTakeAction>

            <ModalTakeAction
                stateShow={data.catatanPengambilan.modal}
                fnHide={() => setData(d => ({
                    ...d,
                    catatanPengambilan: {
                        ...d.catatanPengambilan,
                        modal: false
                    }
                }))}

                stateHideOnClickOutSide={true}
                stateTitle={String('Catatan Pengambilan').toUpperCase()}
                stateOverlayZIndex={201}

                stateButtonClosePx='md'

                stateButtonActionCaption='Submit'
                stateButtonActionPx='xs'
                stateButtonActionColor="blue"
                stateButtonActionLoading={data.catatanPengambilan.submitLoading}
                fnButtonAction={submitCatatanSelesai}
            >
                <Textarea
                    value={data.catatanPengambilan.value}
                    minRows={3}
                    maxRows={4}
                    onChange={(e) => {
                        setData(d => ({
                            ...d,
                            catatanPengambilan: {
                                ...d.catatanPengambilan,
                                value: e.target.value
                            }
                        }))
                    }}

                    label='Catatan'
                    placeholder='Keterangan / Catatan'
                    error=''
                    description=''
                    withAsterisk={false}
                />
            </ModalTakeAction>

            <ModalResponse
                stateShow={data.modalResponse.show}
                fnHide={() => setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        show: false
                    }
                }))}

                stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
                stateType={data.modalResponse.type}
                stateContent={data.modalResponse.content}
            />

            <ModalTakeAction
                stateShow={data.projectRating.modal}
                fnHide={() => setData(d => ({
                    ...d,
                    projectRating: {
                        ...d.projectRating,
                        modal: false
                    }
                }))}

                stateHideOnClickOutSide={true}
                stateTitle={String('Rating Pekerjaan').toUpperCase()}
                stateOverlayZIndex={201}

                stateButtonClosePx='md'

                stateButtonActionCaption='Submit'
                stateButtonActionPx='xs'
                stateButtonActionColor="orange"
                stateButtonActionLoading={data.projectRating.submitLoading}
                fnButtonAction={submitProjectRating}
            >
                <Box
                    mt='sm'
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <RingProgress
                        sections={[{ value: Number(data.projectRating.value) * (100 / utils.projectRating), color: 'orange' }]}
                        thickness={10}
                        label={
                            <Text
                                sx={(tema) => ({
                                    color: tema.colorScheme === 'light' ? tema.colors.yellow[6] : tema.colors.yellow[8]
                                })}
                                weight={500}
                                align="center"
                                size="xl"
                            >
                                {String(Number(data.projectRating.value))}
                            </Text>
                        }
                    />
                </Box>

                <Box
                    mt='sm'
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <Rating
                        value={Number(data.projectRating.value)}
                        onChange={(val) => {
                            setData(d => ({
                                ...d,
                                projectRating: {
                                    ...d.projectRating,
                                    value: Number(val)
                                }
                            }))
                        }}
                        size="lg"
                        count={utils.projectRating}
                        fractions={2}
                    />
                </Box>

                <Box
                    mt='lg'
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <Button
                        variant="subtle"
                        size="xs"
                        color="orange"
                        onClick={() => {
                            setData(d => ({ ...d, projectRating: { ...d.projectRating, value: null } }))
                        }}
                    >
                        Delete Rating
                    </Button>
                </Box>

            </ModalTakeAction>
        </React.Fragment>
    )
}

export default StepSelesaiTotalPembayaran;